<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="width: 1024px;">
      <header class="modal-card-head">
        <p class="modal-card-title">Transactions</p>
      </header>
      <section class="modal-card-body">
        <table class="table is-bordered is-striped is-narrow">
          <thead>
            <tr>
              <td>#</td>
              <td>Account Sub</td>
              <td>Transaction</td>
              <td>User</td>
              <td>Date</td>
              <td>Type</td>
              <td>Value</td>
              <td>Currency</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="transaction in transactions">
              <td>{{transaction.id}}</td>
              <td>{{transaction.account_sub_id}}</td>
              <td>{{transaction.transaction}}</td>
              <td>{{transaction.user.name}}</td>
              <td>{{transaction.created_at}}</td>
              <td>{{parseTransactionType(transaction.transaction_type)}}</td>
              <td>{{transaction.value}}</td>
              <td>{{transaction.currency}}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      account_id: {
        type: Number,
        required: true
      },
      account_sub_id: {
        type: Number,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        transactions: null
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.loadTransactions()
      })
    },
    methods: {
      loadTransactions () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/account/' + this.account_id + '/sub/' + this.account_sub_id + '/transactions').then((response) => {
          this.transactions = response.body
        }, (response) => {
        })
      },
      parseTransactionType (type) {
        if (parseInt(type) === 1) {
          return 'Credit'
        } else if (parseInt(type) === 2) {
          return 'Debit'
        } else if (parseInt(type) === 3) {
          return 'Transfer'
        }
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      }
    },
    components: {
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// AccountSubTransactions.vue?fcf05ac0